module.exports = __webpack_public_path__ + "static/media/p6.5c374794.svg";